import React, { useContext } from 'react';
import DesktopOverlay from './DesktopOverlay';
import MobileOverlay from './MobileOverlay';
import { MobileContext } from '../../../../Context/MobileContext';
var Overlay = function (_a) {
    var deviation = _a.deviation, propShowTitle = _a.showTitle, width = _a.width, className = _a.className, forceVisible = _a.forceVisible, extraActions = _a.extraActions;
    var isMobile = useContext(MobileContext);
    var isSmall = width !== undefined && width < 250;
    return isMobile ? (React.createElement(MobileOverlay, { deviation: deviation, isSmall: isSmall, showTitle: propShowTitle, forceVisible: forceVisible, className: className, extraActions: extraActions })) : (React.createElement(DesktopOverlay, { deviation: deviation, isSmall: isSmall, forceVisible: forceVisible, className: className, extraActions: extraActions }));
};
Overlay.displayName = 'Overlay';
export default Overlay;
//# sourceMappingURL=Overlay.js.map